import { Injectable } from '@angular/core';
import {
  CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot,
  Router
} from '@angular/router';
import { FlowAccessService } from '../_services/flow-access.service';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class FlowNavigationGuard implements CanActivate {

  constructor(private flow: FlowAccessService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const id = route.paramMap.get('id');
    return this.check(state.url, id);
  }

  private check(url: string, id: string): boolean {
    if (this.flow.consume(url)) {
      return true;
    }
    this.router.navigate(['/', environment.defaultLang, 'service-details', id ? id : '']);
    return false;
  }
}
